import React from 'react'
import { Layer, Source, useMap } from 'react-map-gl/maplibre'
import mapSettings from '../mapSettings'

const MapboxSatelliteStreetsLayer = () => {
  const { current: map } = useMap()

  if(!map.getLayer(mapSettings.layerIds.vectorParcelsOutline)) return null

  return (
    <>
      <Source
        id='mapbox-satellite-raster-src'
        type="raster"
        tiles={[`https://api.mapbox.com/styles/v1/loveland/cirw7suml001dg9m9u3uztap0/tiles/256/{z}/{x}/{y}@2x?access_token=${window.data.mapbox.access_token}`]}
        tileSize={256}
        attribution='<a href="https://www.mapbox.com/about/maps/" target="_blank" title="Mapbox" aria-label="Mapbox">© Mapbox</a> <a href="https://www.openstreetmap.org/copyright/" target="_blank" title="OpenStreetMap" aria-label="OpenStreetMap">© OpenStreetMap</a> <a href="https://www.maxar.com/" target="_blank" title="Maxar" aria-label="Maxar">© Maxar</a>'
      >
        <Layer
          id='mapbox-satellite-raster'
          beforeId={mapSettings.layerIds.vectorParcelsOutline}
          source='mapbox-satellite-raster-src'
          type="raster"
        />
      </Source>
    </>
  )
}

export default MapboxSatelliteStreetsLayer
